module.exports = __webpack_public_path__ + "assets/images/6d7b3df5f409b65080956d6b5d2c8052.png";